import styled from 'styled-components';

const MainContent = styled.div`
  display: flex;
  background-color: ${({theme}) => theme.colors.backgroundWhite};
`;

export default MainContent
